<template>
  <div class="footer">
    <div class="footer-logo">
      <img src="@/assets/images/footer/footer-logo.png" alt="" />
    </div>
    <div class="wechat">
      <div class="wechat-text">关注我们</div>
      <div class="wechat-img">
        <img src="@/assets/images/footer/二维码.jpg" alt />
      </div>
    </div>
    <div class="footer-content footer-marginTop35">
      <img
        src="@/assets/images/footer/footer-address.png"
        alt=""
        style="margin-right: 8px"
      />
      <span>苏州高新区科灵路78号苏高新软件园7幢4楼405-406室</span>
    </div>
    <div class="footer-content footer-marginTop8">
      <img
        src="@/assets/images/footer/footer-phone.png"
        alt=""
        style="margin-right: 8px"
      />
      <span>18018171182</span>
    </div>
    <div class="footer-content footer-marginTop8">
      <img
        src="@/assets/images/footer/footer-email.png"
        alt
        style="margin-right: 8px"
      />
      <span>gkkc_sales@163.com</span>
    </div>
    <div class="footer-copyright footer-marginTop35">
      © 2019 - 2025 苏州国科康成医疗科技有限公司
    </div>
    <div class="footer-copyright footer-marginTop8">苏ICP备18058669号-2</div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
.wechat {
  position: absolute;
  right: 300px;
  .wechat-text {
    color: #ffffff;
    font-size: 24px;
    line-height: 60px;
  }
  .wechat-img {
    width: 180px;
    height: 180px;
    img {
      width: 180px;
      height: 180px;
    }
  }
}
.footer {
  width: 100%;
  // height: 412px;
  background-color: #f5f5f5;
  color: #fff;
  text-align: center;
  line-height: 100px;
  background-image: url('@/assets/images/footer/footerBg.png');
  padding: 56px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .footer-logo {
    width: 300px;
    height: 86px;
    img {
      width: 300px;
      height: 86px;
    }
  }
  .footer-marginTop35 {
    margin-top: 35px;
  }
  .footer-marginTop8 {
    margin-top: 8px;
  }

  .footer-content {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    line-height: 26px;
    letter-spacing: 7px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
  }

  .footer-copyright {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 26px;
    letter-spacing: 5px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

@media screen and (max-width: 768px) {
  .footer {
    width: 100%;
    line-height: 100px;
    padding: 110px 0;

    .footer-logo {
      width: 460px;
      height: 110px;
      img {
        width: 460px;
        height: 110px;
      }
    }
    .footer-marginTop35 {
      margin-top: 70px;
    }
    .footer-marginTop8 {
      margin-top: 8px;
    }

    .footer-content {
      font-size: 32px;
      line-height: 52px;
      letter-spacing: 14px;
      img {
        width: 64px;
        height: 64px;
      }
    }

    .footer-copyright {
      font-weight: 400;
      font-size: 28px;
      line-height: 52px;
      letter-spacing: 10px;
    }
  }
}
</style>
